import { Logo } from "@/view/components/ui/logo";
import { ThemeToggle } from "@/view/components/ThemeToggle";

export function CreditHeader() {

  return (
    <div className="w-full border-b-2 p-4 border-white pb-2 dark:bg-gray-950 dark:border-gray-800">
      <div className="relative flex items-center justify-center">
        <div className="h-12 max-w-[12rem] dark:bg-white dark:rounded-lg dark:px-3 dark:py-1">
          <Logo className="h-full object-contain" />
        </div>
        <div className="absolute right-0 top-1/2 -translate-y-1/2">
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
}
